import { OfferService } from 'src/app/shared/service/offer.service';
import { ActionLogForOffer } from '../../../../model/action-log-for-offer.model';
import { Component, OnInit, Input } from '@angular/core';
import { MatchingOffer } from 'src/app/shared/model/matching-offer.model';
import { MailInfo } from '../../../../model/mail-info.model';

@Component({
  selector: 'app-matching-label',
  templateUrl: './matching-label.component.html',
  styleUrls: ['./matching-label.component.scss']
})
export class MatchingLabelComponent implements OnInit {
  @Input() side: string;
  @Input() mailInfo: MailInfo;
  @Input() matchingOffer: MatchingOffer;
  @Input() orderFinished: string;
  @Input() timeOut: boolean;
  @Input() actionLog: ActionLogForOffer;

  constructor(public offerService: OfferService) {}

  ngOnInit() {}

  // ------------------------------
  // オファーサイド確認
  // 2020/08/12 使われてない？
  isProjectSide(): boolean {
    return this.side === 'project';
  }
  isWorkerSide(): boolean {
    return this.side === 'worker';
  }
  // ------------------------------

  isOffered(): boolean {
    return this.matchingOffer.progress_status !== null;
  }

  searchOffer($event: any) {
    $event.stopPropagation();
    const ai_mail_id = this.mailInfo.ai_mail_id;
    window.open(`/offer?keyword=${ai_mail_id}`, '_blank');
  }
}
